{
  "confirmInvalidateDescription": "Les autres fermes ne pourront plus utiliser ce code pour ajouter cet appareil à leur compte",
  "createDeviceShareCodeInstructions": "Définissez les autorisations pour les fermes qui utiliseront cet appareil.",
  "createDeviceShareCodeSuccessMessage": "Votre code de partage a été créé avec succès.",
  "currentDeviceShareCode": "Code actuel",
  "deviceOwnership": "Propriété de l'appareil",
  "deviceOwnershipLinkTo": "Possession",
  "farmsBorrowingDeviceListEmpty": "Aucune ferme n'emprunte actuellement cet appareil.",
  "helpContent": "Les appareils peuvent être partagés avec d'autres batteries de serveurs à l'aide d'un code de partage d'appareils. Vous pouvez accorder l'accès aux utilisateurs extérieurs à votre batterie de serveurs et leur attribuer des autorisations spécifiques lorsqu'ils utilisent l'appareil.",
  "invalidateButton": "Invalider",
  "newDeviceShareCode": "Nouveau code de partage d'appareil",
  "primaryOwnerLabel": "Propriétaire principal",
  "requestDeviceRemovalButton": "Supprimer l'appareil",
  "requestDeviceRemovalDescription": "L'appareil sera supprimé de ce compte de ferme.",
  "requestDeviceRemovalInstructions": "Pour continuer, saisissez l’alias de l’appareil.",
  "requestDeviceRemovalNote": "Remarque : cette action n'affectera pas la facturation",
  "requestDeviceRemovalTitle": "Demande de suppression d'appareil",
  "requestRemovalALiasMustMatchErrorMessageWithCodaDeviceAlias": "L'alias doit correspondre exactement à {{codaDeviceAlias}}.",
  "shareDeviceShareCodeMessagePrefixWithCodeStrAndDeviceName": "Saisissez ce code pour accéder à l'appareil FarmHQ {{deviceName}} : {{codeStr}}",
  "shareTitlePrefixWithFarmName": "[FarmHQ] : code de partage d'appareil de {{farmName}}"
}
